import type { ResourceQueryKey, ResourceQueryReference } from "./definition";

/**
 * 写操作能对读缓存做的事：取消在途请求、让整个资源失效。
 * 乐观更新暂未落地，等真有需要回滚的写操作时再补，不预留空壳。
 */
export interface ResourceCache {
  cancel: (query: ResourceQueryReference) => Promise<void>;
  invalidate: (query: ResourceQueryReference) => Promise<void>;
}

interface ResourceQueryClient {
  cancelQueries(filters: { queryKey: ResourceQueryKey }): Promise<unknown>;
  invalidateQueries(filters: { queryKey: ResourceQueryKey }): Promise<unknown>;
}

export function createResourceCache(
  queryClient: ResourceQueryClient,
): ResourceCache {
  return {
    async cancel(query) {
      await queryClient.cancelQueries({ queryKey: query.scopeKey });
    },
    async invalidate(query) {
      await queryClient.invalidateQueries({ queryKey: query.scopeKey });
    },
  };
}
